import type { CarouselPaginationDotsProps } from "./types/carousel-pagination-dots.types";
import { carouselPaginationDotsStyles, carouselPaginationDotStyles } from "./styles/carousel-navigation.styles";

export const CarouselPaginationDots: React.FC<CarouselPaginationDotsProps> = (props) => {
  const { activeIndex, total, scrollTo } = props;

  return (
    <div className={carouselPaginationDotsStyles()}>
      {Array.from({ length: total }, (_, index) => (
        <button
          key={index}
          type="button"
          onClick={() => scrollTo?.(index)}
          className={carouselPaginationDotStyles({ active: index === activeIndex })}
        >
          <span className="sr-only">Go to slide {index + 1}</span>
        </button>
      ))}
    </div>
  );
};
